import styled from '@emotion/styled'
import { Button } from 'antd'
import { Sidebar, MenuItem, SubMenu } from 'react-pro-sidebar'

export const SidebarBtn = styled.a<{
  isdark: boolean
}>`
  display: inline-block;
  transition: width 0.3s;
  color: ${(props) => (props.isdark ? '#fff' : '#000')};
  text-decoration: none;
  margin: 0 auto;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  span {
    margin-left: 5px;
    font-size: 13px;
  }
  &:hover {
    color: ${(props) => (props.isdark ? '#fff' : '#000')};
  }
`

export const ProSidebarCus = styled(Sidebar)<{
  isdark: string
}>`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: auto;

  .ps-sidebar-container {
    background: ${(props) =>
      props.isdark === 'true' ? 'rgba(0, 0, 0, 0.05)' : '#fff'};
    backdrop-filter: blur(50px);
  }
`

export const MenuItemCus = styled(MenuItem)<{
  active?: boolean
  isdark: string
}>`
  .ps-menu-button {
    margin: 4px;
    border-radius: 5px;
    background: ${(props) =>
      props.active ? 'rgba(15,104,170,0.2)' : 'initial'};
  }
  .ps-menu-button:hover {
    background-color: rgba(15, 104, 170, 0.2) !important;
  }
  a {
    color: ${(props) =>
      props.isdark === 'true' ? '#fff!important' : '#333!important'};
  }
`

export const SubMenuCus = styled(SubMenu)<{
  isdark: string
}>`
  .ps-menu-button {
    margin: 8px 4px 4px 0px;
    border-radius: 5px;
  }
  .ps-menu-button:hover {
    background-color: rgba(15, 104, 170, 0.2) !important;
  }
  .ps-submenu-content {
    background-color: ${(props) =>
      props.isdark === 'true' ? '#051F31!important' : 'initial'};
  }
`

export const SubMenuItemCus = styled(MenuItem)<{
  isactive: string
  isdark: string
}>`
  .ps-menu-button {
    border-radius: 5px;
    background: ${(props) =>
      props.isactive === 'true' ? 'rgba(15,104,170,0.2)' : 'initial'};
  }
  .ps-menu-button:hover {
    background-color: rgba(15, 104, 170, 0.2) !important;
  }
  a {
    color: ${(props) =>
      props.isdark === 'true' ? '#fff!important' : '#333!important'};
  }
  .ps-menu-label {
    display: inline-block;
    margin-left: 20px;
    font-size: 12px;
  }
`

export const SubMenuItemCus1 = styled(MenuItem)<{
  isactive: string
  isdark: string
}>`
  .ps-menu-button {
    height: 35px;
    padding-left: 0px !important;
    border-radius: 5px;
    background: ${(props) =>
      props.isactive === 'true' ? 'rgba(15,104,170,0.2)' : 'initial'};
  }
  .ps-menu-button:hover {
    background-color: rgba(15, 104, 170, 0.2) !important;
  }
  a {
    color: ${(props) =>
      props.isdark === 'true' ? '#818d96!important' : '#818d96!important'};
  }
  .ps-menu-label {
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
  }
`

export const SidebarFooterCus = styled.div`
  border-top: none !important;
  width: 100%;
  margin-top: 40px;
`

export const ThirdPartyCon = styled.div`
  display: flex;
  padding: 0 10%;
  width: 100%;
  justify-content: space-around;
`

export const Div1 = styled.div`
  width: 100%;
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`

export const Img = styled.img`
  width: 20px;
`

export const Img2 = styled.img`
  width: 18px;
`

export const LineStyle = styled.div<{
  isdark: boolean
}>`
  border-bottom: ${(props) =>
    props.isdark ? '1px solid #273A48' : '1px solid #EBEFF2'};
  width: 100%;
`

export const ButtonNoPadding = styled(Button)`
  padding: 0;
  display: flex;
  align-items: flex-end;
  height: 100%;
`
